<template>
  <div class="appTotal-wrap">
    <div class="appTotal-bg">
      <Card-border></Card-border>
      <div class="appTotal-title">APP 资产总数</div>
      <div class="appTotal-num">
        <CountUp
          :startVal="0"
          :endVal="props.data.assetsNum || 0"
          index="largeScreenAppTotal"
        />
      </div>
      <div class="appTotal-box" @click="handleLinkTo('andriod')">
        <div class="app-icon">
          <img :src="require(`@/assets/images/andriod.png`)" />
        </div>
        <div class="app-content">
          <div class="box-title">Android 应用</div>
          <div class="box-num">
            <CountUp
              :startVal="0"
              :endVal="props.data.android || 0"
              index="largeScreenAppTotalAndroid"
            />
          </div>
        </div>
      </div>
      <div class="appTotal-box" @click="handleLinkTo('ios')">
        <div class="app-icon">
          <img :src="require(`@/assets/images/ios.png`)" />
        </div>
        <div class="app-content">
          <div class="box-title">iOS 应用</div>
          <div class="box-num">
            <CountUp
              :startVal="0"
              :endVal="props.data.ios || 0"
              index="largeScreenAppTotalIos"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardBorder from "@/components/common/card-border.vue";
import CountUp from "@/components/common/countup.vue";

export default {
  props: {
    data: Object,
  },
  components: {
    CardBorder,
    CountUp
  },
  setup(props) {
    const handleLinkTo = (type) => {
      const url = type === 'andriod' ? '/#/safemonitor/scan/list' : '/#/safemonitor/iosScan/list';
      window.location.href = url;
    };

    return {
      props,
      handleLinkTo
    };
  }
}
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
